import { Controller } from "@hotwired/stimulus"

// Handles cart item removal in the cart overview form.
// Clicking a .remove link sets the row's quantity to 0 and submits
// the form with refresh=1, which triggers the wicked wizard to re-render.
export default class extends Controller {
  remove(event) {
    event.preventDefault()

    const row = event.currentTarget.closest("tr")
    const qInput = row?.querySelector("input[id$=quantity]")
    if (qInput) qInput.value = 0

    const refreshInput = document.createElement("input")
    refreshInput.type  = "hidden"
    refreshInput.name  = "refresh"
    refreshInput.value = "1"
    this.element.appendChild(refreshInput)
    this.element.requestSubmit()
  }
}
